import React from 'react'
import styled from 'styled-components'
import Radium from 'radium'
import loSto from '../config/loSto'
import {
  getAllScriptsForUser,
  getAllNotetypesForUser,
  getScriptName,
  LO_STO,
  SETTINGS_VIEW,
  HALF_STORY,
  ROUTES,
  AGENT_CONFIGS,
  setToast
} from '../lib'
import { Constants } from '@sukiai/components'
import { SET_MODAL } from '../apollo/actions'
import { CLOSE_MODAL } from '../constants/pubSub.events'
import pubSub from '../lib/util/pubSub'
import { MODALS } from '@sukiai/components/lib/constants'
import { withApollo } from 'react-apollo'
import { logger, halfStory as hs } from '../lib/logging'
import closeButton from '../lib/assets/icons/closeButton.png'
import { DeleteNoteTypes, DeleteScript } from '@sukiai/gql/app'
import DeleteItemModal from './DeleteItemModal'

const { TOAST } = Constants

const Sidebar = styled.div`
  height: 100%;
  margin: 20px 20px 0px 0px;
  display: flex;
  flex-direction: column;
  width: 240px;
`

const SidebarItem = styled.div`
  width: 100%;
  height: 50px;
  padding: 5px 0px 5px 16px;
  background-color: ${props => props.active ? '#2e5f62' : 'none'};
  color: ${props => props.active ? 'white' : 'none'};
  border-radius: 4px;
  display: flex;
  align-item: center;
  box-sizing: border-box;
`

const SidebarText = styled.div`
  transform: translateY(12.5%);
`

const Body = styled.div`
  display: flex;
  height: 400px;
  width: 100%;
  position: relative;
  padding: 0px 18px;
  box-sizing: border-box;
`

const CloseModalButton = styled.img.attrs({
  src: closeButton
})`
  width: 30px;
  height: 30px;
  &:hover {
    cursor: pointer;
  };
  position: absolute;
  top: 0;
  right: 0;
  margin: 24px 30px 0px 0px;
  transform: translateY(15%);
`

const ItemsHeader = styled.div`
  padding: 10px 10px 20px 10px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
`

const CreateItemButton = styled.div`
  padding: 1px 10px 0 10px;
  border-radius: 4px;
  border: solid 1px rgba(0, 0, 0, 0.25);
  height: 28px;
  text-align: center;
  margin: 0px 20px;
  font-size: 12pt;
  &:hover {
    background-color: white;
  }
  @media (max-width: 1250px) {
    margin: 0;
  }
`

const Item = styled.div`
  display: flex;
  width: 100%;
  &:hover {
    background-color: white;
  };
  padding: 12px;
  box-sizing: border-box;
`

const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 10px 20px 10px 10px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
`

const DeleteSectionButton = styled.img.attrs({
  src: closeButton
})`
  width: 26px;
  height: 26px;
  margin: 0px 20px 0px auto;
`

const ModalContainer = styled.div.attrs({
  onClick: e => e.stopPropagation()
})`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px auto;
  width: 800px;
  min-width: 600px;
  background: rgb(248,249,247);
  box-shadow: 0px 0px 10px rgba(1,1,1,0.2);
  z-index: 10000;
  font-size: 15pt;
  @media (max-width: 1000px) {
    width: 75%;
  }
`

const styles = {
  mainContent: {
    width: '100%'
  },
  radioOption: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    fontSize: '15pt'
  },
  icon: {
    width: '24px',
    height: '24px',
    paddingRight: '20px'
  },
  selectButton: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    textAlign: 'center',
    color: '#2E5F62',
    width: '99%',
    height: '46px',
    borderRadius: '8px',
    border: '1px solid #2E5F62',
    marginLeft: 'auto',
    paddingLeft: '20px',
    fontSize: '15pt',
    cursor: 'pointer'
  },
  headingContainer: {
    padding: '30px 20px 34px 20px',
    fontWeight: '600',
    fontSize: '15pt',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    borderBottom: '1px solid rgb(0,0,0,0.25)'
  },

  divider: {
    width: '100%',
    height: '40px',
    textAlign: 'center'
  },
  optionLabel: {
    fontSize: '14pt',
    letterSpacing: '0.01em',
    marginLeft: '20px',
    fontWeight: '600'
  },
  loading: {
    margin: '40px 0px',
    position: 'relative'
  }
}

class SettingsModal extends React.Component {
  state = {
    settingView: this.props.selectType || loSto.get(LO_STO.SETTINGS_VIEW) || SETTINGS_VIEW.SCRIPTS,
    allScripts: [],
    allNotetypes: [],
    preventDeleteAllNts: false
  }

  componentWillMount () {
    this.getScripts()
    this.getNotetypes()
  }

  componentDidMount () {
    if (!window.location.pathname.includes(ROUTES.NOTE)) {
      loSto.set(LO_STO.LAST_AGENT_POSITION, AGENT_CONFIGS.FORCE_MIDDLE)
    }
    const openModalsList = loSto.get('OPEN_MODALS') || []
    openModalsList.push('settingsModal')
    loSto.set('OPEN_MODALS', openModalsList)
    this.goBackSubscription = pubSub.subscribe(CLOSE_MODAL, () => {
      this.handleClose()
    })
  }

  componentWillReceiveProps (nextProps) {
    nextProps.shouldDismiss && this.props.open && nextProps.removeModal()
  }

  handleAddScript = () => {
    const { handleCreateNewScript } = this.props
    handleCreateNewScript()
  }

  handleClose = () => {
    this.removeModalFromOpenModalsList()
    this.props.dismiss()
  }

  removeModalFromOpenModalsList = () => {
    const openModalsList = loSto.get('OPEN_MODALS')
    const settingsModalIndex = openModalsList ? openModalsList.indexOf('settingsModal') : null
    if (settingsModalIndex || settingsModalIndex === 0) {
      openModalsList.splice(settingsModalIndex, 1)
      loSto.set('OPEN_MODALS', openModalsList)
    }
  }

  handleAddNotetype = () => {
    const { handleAddNotetype } = this.props
    handleAddNotetype()
  }

  openDoctorScriptEditor = async script => {
    const { client, setCurrentScript } = this.props

    setCurrentScript(script)

    client.mutate({
      mutation: SET_MODAL,
      variables: {
        content: {
          __typename: 'ModalContent',
          type: MODALS.SCRIPT_DETAILS,
          heading: getScriptName(script)
        }
      }
    })
  }

  getScripts = async () => {
    const scripts = await getAllScriptsForUser()
    this.setState({ allScripts: scripts })
  }

  getNotetypes = async () => {
    const notetypes = await getAllNotetypesForUser()
    const userNotetypes = notetypes.filter(nt => nt.userId)
    if (notetypes.length === userNotetypes.length) {
      // If there are no org level notetypes, prevent last nt from being deleted
      this.setState({ preventDeleteAllNts: true })
    }
    this.setState({ allNotetypes: userNotetypes })
  }

  handleScriptMouseOver = scriptId => {
    this.setState({ showDeleteScript: scriptId })
  }

  handleScriptMouseLeave = () => {
    this.setState({ showDeleteScript: '' })
  }

  openDeleteScriptModal = (e, scriptId) => {
    e.preventDefault()
    this.setState({ showDeleteModal: scriptId })
  }

  handleOpenScript = (e, scriptId) => {
    if (e.target.classList.contains('delete-script-button')) {
      return
    }
    this.props.openScriptDetails(scriptId)
  }

  renderScripts = () => {
    const { allScripts, showDeleteScript } = this.state

    const scriptElements = allScripts.map((s, i) => {
      const showDeleteButton = showDeleteScript === s.id
      return (
        <Item
          onClick={e => this.handleOpenScript(e, s.id)}
          key={i}
          onMouseOver={() => this.handleScriptMouseOver(s.id)}
          onMouseLeave={() => this.handleScriptMouseLeave()}
        >
          {getScriptName(s)}
          {showDeleteButton &&
            <DeleteSectionButton
              onClick={e => this.openDeleteScriptModal(e, s.id)}
              className='delete-script-button'
            />}
        </Item>
      )
    })

    return (
      <div style={{ position: 'relative', height: '300px', padding: '10px 10px 10px 0px', overflow: 'auto' }}>
        {scriptElements}
      </div>
    )
  }

  handleMouseOver = ntId => {
    this.setState({ showDeleteNt: ntId })
  }

  handleMouseLeave = () => {
    this.setState({ showDeleteNt: '' })
  }

  onDeleteScript = () => {
    const { client } = this.props
    const { allScripts, showDeleteModal } = this.state

    const scriptId = showDeleteModal
    const idxToDelete = allScripts.findIndex(s => s.id === scriptId)
    const newScripts = [...allScripts]
    newScripts.splice(idxToDelete, 1)

    this.setState({ allScripts: newScripts })

    client.mutate({
      mutation: DeleteScript,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        id: scriptId
      }
    }).then(() => {
      console.info('Successfully deleted script')
      logger.info('Deleted script via physician script editor')
      hs.add(HALF_STORY.SCRIPT_UPDATED, `Deleted script ${scriptId} via physician script editor`)
      this.setState({ showDeleteModal: '' })
    }).catch(err => {
      console.error('Error deleting script', err)
      this.setState({ showDeleteModal: '' })
    })
  }

  onDeleteNotetype = () => {
    const { client } = this.props
    const { allNotetypes, showDeleteModal, preventDeleteAllNts } = this.state

    if (preventDeleteAllNts && allNotetypes.length === 1) {
      setToast(TOAST.TYPE.ERROR, 'You must have at least one Note Type.', TOAST.DURATION.MEDIUM)
      return
    }

    const ntId = showDeleteModal
    const idxToDelete = allNotetypes.findIndex(nt => nt.id === ntId)
    const newNotetypes = [...allNotetypes]
    newNotetypes.splice(idxToDelete, 1)

    this.setState({ allNotetypes: newNotetypes })

    client.mutate({
      mutation: DeleteNoteTypes,
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        ids: [ntId]
      }
    }).then(res => {
      console.info('Successfully deleted notetype')
      logger.info('Deleted notetype via physician notetype editor')
      hs.add(HALF_STORY.NOTETYPE_UPDATED, `Deleted notetype ${ntId} via physician notetype editor`)
      this.setState({ showDeleteModal: '' })
    }).catch(err => {
      console.error('Error deleting notetype', err)
      this.setState({ showDeleteModal: '' })
    })
  }

  openDeleteNotetypeModal = (e, ntId) => {
    e.preventDefault()
    this.setState({ showDeleteModal: ntId })
  }

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: '' })
  }

  handleOpenNotetype = (e, ntId) => {
    if (e.target.classList.contains('delete-section-button')) {
      return
    }
    this.props.openNotetype(ntId)
  }

  renderNotetypes = () => {
    const { allNotetypes, showDeleteNt } = this.state

    const ntElements = allNotetypes.map((n, i) => {
      const showDeleteButton = showDeleteNt === n.id
      return (
        <Item
          onClick={e => this.handleOpenNotetype(e, n.id)}
          key={i}
          onMouseOver={() => this.handleMouseOver(n.id)}
          onMouseLeave={() => this.handleMouseLeave()}
        >
          {n.name}
          {showDeleteButton &&
            <DeleteSectionButton
              data-cy={`settings-modal-delete-${n.name.toLowerCase()}`}
              onClick={e => this.openDeleteNotetypeModal(e, n.id)}
              className='delete-section-button'
            />}
        </Item>
      )
    })

    return (
      <div style={{ position: 'relative', height: '300px', padding: '10px 10px 10px 0px', overflow: 'auto' }}>
        {ntElements}
      </div>
    )
  }

  render () {
    const { settingView, showDeleteModal } = this.state

    let items = []
    let title = ''
    let createItemString = ''
    let deleteItemString = ''
    let onDeleteItem = () => { }
    let handleAdd = () => { }
    if (settingView === SETTINGS_VIEW.SCRIPTS) {
      items = this.renderScripts()
      title = 'Scripts'
      createItemString = 'Add Script'
      deleteItemString = 'Delete Script?'
      onDeleteItem = this.onDeleteScript
      handleAdd = this.handleAddScript
    } else if (settingView === SETTINGS_VIEW.NOTETYPES) {
      items = this.renderNotetypes()
      title = 'Note Types'
      createItemString = 'Add Note Type'
      deleteItemString = 'Delete Note Type?'
      onDeleteItem = this.onDeleteNotetype
      handleAdd = this.handleAddNotetype
    }

    return (
      <ModalContainer>
        <div style={{ width: '100%', position: 'relative' }}>
          <div style={styles.headingContainer}>
            <div style={styles.headingTitle}>
              Settings
            </div>
            <CloseModalButton data-cy='settings-modal-close-button' onClick={this.handleClose} />
          </div>
          <Body>
            <Sidebar>
              <SidebarItem
                onClick={() => this.setState({ settingView: SETTINGS_VIEW.SCRIPTS })}
                active={settingView === SETTINGS_VIEW.SCRIPTS}
              >
                <SidebarText>
                  Scripts
                </SidebarText>
              </SidebarItem>
              <SidebarItem
                onClick={() => this.setState({ settingView: SETTINGS_VIEW.NOTETYPES })}
                active={settingView === SETTINGS_VIEW.NOTETYPES}
              >
                <SidebarText data-cy='note-types'>
                  Note Types
                </SidebarText>
              </SidebarItem>
            </Sidebar>
            <Content data-cy='settings-content'>
              <div style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between'
              }}
              >
                <ItemsHeader data-cy={`settings-itemheader-${title.replace(/\s/g, '_')}`}>
                  {title}
                </ItemsHeader>
                <CreateItemButton data-cy={`settings-create-item-${createItemString.replace(/\s/g, '_')}`} onClick={handleAdd}>
                  {createItemString}
                </CreateItemButton>
              </div>
              {items}
            </Content>
          </Body>
        </div>
        {showDeleteModal &&
          <DeleteItemModal
            data-cy='settings-modal-confirm-delete'
            handleDelete={onDeleteItem}
            handleClose={this.closeDeleteModal}
            deleteString={deleteItemString}
          />}
      </ModalContainer>
    )
  }
}

export default Radium(withApollo(SettingsModal))
